import Recaptcha from 'client/pages/contact-us/entities/Recaptcha'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { TextAreaInterface } from 'common/types/entities/TextAreaInterface'
import React from 'react'
import ContactUsButton from 'src/editor/pages/contact-us/entities/contact-us-button'
import { ContactUsField } from 'src/editor/pages/contact-us/entities/contact-us-field'
import { FieldNew } from 'src/editor/shared/entities/field-new'
import { Form } from 'src/editor/shared/entities/form'
import { ButtonEntityInterface } from 'src/shared/entities/button/button.schema'
import { ContactUsButtonEntityInterface } from 'src/shared/entities/contact-us-button/contact-us-button-entity.schema'
import { ContactUsFieldEntityInterface } from 'src/shared/entities/contact-us-field/contact-us-field-entity.schema'
import { FieldEntityInterface } from 'src/shared/entities/field/field-entity.schema'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { AttachmentsInterface } from 'src/shared/types/entities/attachments-interface'
import ButtonNew from '../../components/entities/button-new'
import createCommonEntityElement, {
  AdditionalProps,
} from '../createCommonEntityElement'
import Attachments from './entities/Attachments'
import ContactUs from './entities/ContactUs'
import TextArea from './entities/TextArea'

export default function createEntityElementForContactUs(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.ContactUs:
      return (
        <ContactUs entity={entity as ContactUsInterface} {...additionalProps} />
      )
    case EntityTypeEnum.TextArea:
      return (
        <TextArea entity={entity as TextAreaInterface} {...additionalProps} />
      )
    case EntityTypeEnum.Form:
      return <Form entity={entity as FormInterface} {...additionalProps} />
    case EntityTypeEnum.Field:
      return (
        <FieldNew
          entity={entity as FieldEntityInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.ContactUsField:
      return (
        <ContactUsField
          entity={entity as ContactUsFieldEntityInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Recaptcha:
    case EntityTypeEnum.ContactUsRecaptcha:
      return (
        <Recaptcha entity={entity as RecaptchaInterface} {...additionalProps} />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonNew
          entity={entity as ButtonEntityInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.ContactUsButton:
      return (
        <ContactUsButton
          entity={entity as ContactUsButtonEntityInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Attachments:
      return (
        <Attachments
          entity={entity as AttachmentsInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(entity, additionalProps)
  }
}
